import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useDetailQueryState } from '~/hooks/reactQuery/useDetailQueryState';
export function useCustomerDetail(clientId) {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const _useDetailQueryState = useDetailQueryState({
        queryKey: [
            QueryKeys.CustomerDetail,
            clientId
        ],
        queryFn: ()=>api.client.getById(clientId),
        enabled: enabled && clientId !== '',
        refreshOnHookMount
    }), { data } = _useDetailQueryState, state = _object_without_properties(_useDetailQueryState, [
        "data"
    ]);
    return _object_spread({
        clientDetails: data
    }, state);
}
